import { IdTokenResult, ParsedToken } from '@angular/fire/auth';

export enum PlanType {
  Basic = 'basic',
  Follower = 'follower',
  Premium = 'premium',
  Beta = 'beta',
}

export const PlanLevel = {
  [PlanType.Basic]: { level: 1 },
  [PlanType.Follower]: { level: 2 },
  [PlanType.Beta]: { level: 3 },
  [PlanType.Premium]: { level: 4 },
};

export enum PermissionType {
  Vocabulary = 'vocabulary',
  LearningExampleRequest = 'leRequest',
  Conversation = 'conversation',
}

export enum RolType {
  Admin = 'admin',
  Teacher = 'teacher',
  Tester = 'tester',
  Follower = 'follower',
}

export type PermissionClaim = Record<PermissionType, { exp: Date; num: number }>;

export type SubscriptionClaim = { type: PlanType; exp?: Date };

export type RolClaim = Record<RolType, null | string | Date>;

export enum TokenStatus {
  Pending = 'pending', // means something is happening.
  Welcome = 'welcome', // force refresh, next time user logs in, token has changed.
  Refresh = 'refresh', // force refresh, next time user logs in, token has changed.
  None = null, // No estatus,
}

// This is what is saved in user.claims
export interface AppAuthClaims {
  plan: SubscriptionClaim;
  permissions: PermissionClaim;
  roles: RolClaim;
  status: TokenStatus;
}

// This is what is saved in Firebase token  AppAuthClaims merged with some other properties
export type TokenFBClaims = ParsedToken & AppAuthClaims;

export enum ActionPromoCode {
  FreePermission = 'freePermission',
  FreePlan = 'freePlan',
  PlanDiscount = 'planDiscount',
}

// TODO: esto es más de polilian refactorizar después.
export const PermissionsOptions = [
  { name: 'Vocabulario', value: PermissionType.Vocabulary },
  { name: 'Conversaciones', value: PermissionType.Conversation },
  { name: 'Búsquedas Ejemplos', value: PermissionType.LearningExampleRequest },
];

// TODO: those are rols from polilan refactor later.
export const RolOptions = [
  { name: 'Administrador', value: RolType.Admin },
  { name: 'Profesor', value: RolType.Teacher },
  { name: 'Tester', value: RolType.Tester },
];

export const PlanOptions = [
  { name: 'Básico', value: PlanType.Basic },
  { name: 'Beta', value: PlanType.Beta },
  { name: 'Follower', value: PlanType.Follower },
  { name: 'Premium', value: PlanType.Premium },
];

//
export const ExpireDateOptions = [
  { name: 'No expira', value: null },
  { name: '1 Mes', value: 1 },
  { name: '2 Meses', value: 2 },
  { name: '3 Meses', value: 3 },
  { name: '4 Meses', value: 4 },
  { name: '6 Meses', value: 6 },
  { name: '1 Año', value: 12 },
];

export const StatusOptions = [
  // { name: 'Pending', value: 'pending' },
  { name: 'Refrescar Token', value: 'refresh' },
  { name: 'Welcome to Premium', value: 'welcome' },
  { name: 'None', value: null },
];
